<template>
    <div class="embodiment-config-rule rounded-lg p-2">
        <div class="mb-2 flex items-center">
            <p class="leading-5 text-sm flex-grow text-gray-1100">
                <span>{{ t('aiSpecification.embodiment.embodiment') }}</span>
                {{ index }}
            </p>
            <div class="shrink-0">
                <slot name="extra" />
            </div>
        </div>
        <div class="flex items-start gap-2">
            <div class="w-[120px]">
                <ElSelect
                    v-model="modelValue.type"
                    :placeholder="t('aiSpecification.embodimentOutline.selectTypePlaceholder')"
                    size="small"
                    :disabled="disabled"
                    :teleported="false"
                    :popperOptions="{
                        strategy: 'fixed',
                    }"
                >
                    <ElOption
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                    <template #suffix>
                        <SvgIcon icon="SolidArrowDown" />
                    </template>
                    <template #prefix>
                        <span class="text-gray-450">{{ t('aiSpecification.embodimentOutline.type') }}:</span>
                    </template>
                </ElSelect>
            </div>
            <div class="w-fit">
                <ClaimTreeSelector
                    v-model="modelValue.claims"
                    class="max-w-[400px]"
                    :claimTree="claimTree"
                    :disabled="disabled"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ElSelect, ElOption } from 'element-plus';
import SvgIcon from '@telecom/shared/components/SvgIcon.vue';
import ClaimTreeSelector from './components/ClaimTreeSelector.vue';
import { useClaimTree } from '../../composables/use-claim-tree';
import type { EmbodimentOutlineConfigRule } from '../../composables/use-specification-embodiment-outline';
import { useI18n } from 'vue-i18n';
import { useSpecificationTaskCreateService } from '../../composables/use-specification-task-create-service';
import { getSpecificationEmbodimentTypes } from '@/domains/specification/utils/jurisdiction';

import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';

defineProps<{
    index: number;
    disabled?: boolean;
}>();

const { t } = useI18n();

const { claimTree } = useClaimTree();

const modelValue = defineModel<EmbodimentOutlineConfigRule>({
    required: true,
});

const { state: taskCreateState } = useSpecificationTaskCreateService();

const options = computed(() => {
    return getSpecificationEmbodimentTypes(taskCreateState.value.formData.jurisdiction).map(type => ({
        value: type,
        label: type,
    }));
});
</script>

<style lang="scss">
.embodiment-config-rule {
    .el-select__selected-item {
        @apply text-black font-semibold;
    }
}
</style>
